<div class="custom-popup">
  <!-- Close Button -->
  @if (data.config.showCloseButton !== false) {
  <a class="popup-close-btn" (click)="close()" aria-label="Close popup">
    <cds-icon [icon]="cancelIcon"></cds-icon>
  </a>
  }

  <!-- Title -->
  @if (data.config.title) {
  <h2 class="popup-title">{{ data.config.title }}</h2>
  }

  <!-- Content -->
  <div class="popup-content">
    @if (data.config.content) {
    <p class="popup-text" [innerHTML]="data.config.content"></p>
    }

    <!-- Custom content projection slot -->
    <ng-content></ng-content>
  </div>

  <!-- Buttons -->
  @if (data.config.buttons && data.config.buttons.length > 0) {
  <div class="popup-actions">
    @for (button of data.config.buttons; track $index) {
    <app-button [fullWidth]="true" [halfHeight]="true" [variant]="getButtonVariant(button.style ?? '')"
      (buttonClick)="onButtonClick(button, $index)">
      {{ button.label }}
    </app-button>
    }
  </div>
  }
</div>